import { apiGet } from './default'

function getSnapshot({id, fields, since=1}) {
    let query = `iserver/marketdata/snapshot?conids=${id}`;
    query += `&fields=${fields}`;
    return apiGet(`/portal.proxy/v1/mkt/${query}`);
}

export default {
    getSnapshot
}
